
import React from 'react';

const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: 'ri-building-2-line',
      title: '実学主義の徹底',
      subtitle: '校内起業と収益還元システム',
      description: '生徒が実際にビジネスを立ち上げ、得た収益を還元。理論だけでなく実践を通して経済原理を学び、社会で通用する実力を身につけます。',
      color: 'blue',
      tags: ['校内起業', 'ペイバック'],
      image: 'https://public.readdy.ai/ai/img_res/674829bf35fdffdfc5166a3673144ee7.jpg'
    },
    {
      icon: 'ri-team-line',
      title: '「リアル」なコミュニティ',
      subtitle: '6都市クラスと行事',
      description: '全国6都市にクラスを設置し、オンラインとオフラインを融合。地域を超えた交流と、実際に会える関係性で豊かな学校生活を実現します。',
      color: 'teal',
      tags: ['リアル交流', '6都市クラス'],
      image: 'https://readdy.ai/api/search-image?query=Diverse%20Japanese%20students%20from%20different%20cities%20connecting%20and%20collaborating%20in%20both%20online%20virtual%20meetings%20and%20real%20physical%20gatherings%20showing%20hybrid%20community%20learning%20modern%20technology%20integration%20with%20human%20connection%20bright%20collaborative%20atmosphere%20students%20appearing%20engaged%20and%20happy&width=400&height=300&seq=community-connection&orientation=landscape'
    },
    {
      icon: 'ri-brain-line',
      title: '次世代教育メソッド',
      subtitle: 'アウトプット重視とBTC式',
      description: '「教わる」から「教える」へ。BTC式（Build-Teach-Challenge）で学んだことを他の生徒に教え、さらなる挑戦へ。真の理解と成長を促進します。',
      color: 'purple',
      tags: ['BTC式', 'アウトプット重視'],
      image: 'https://readdy.ai/api/search-image?query=Japanese%20high%20school%20student%20confidently%20teaching%20and%20presenting%20to%20peers%20in%20innovative%20classroom%20setting%20with%20interactive%20whiteboards%20and%20modern%20learning%20tools%20showing%20student-centered%20education%20bright%20encouraging%20atmosphere%20students%20actively%20participating%20and%20engaged%20in%20collaborative%20learning&width=400&height=300&seq=teaching-learning&orientation=landscape'
    }
  ];

  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      icon: 'text-blue-600',
      accent: 'text-blue-800',
      border: 'border-blue-200',
      tag: 'bg-blue-100 text-blue-800'
    },
    teal: {
      bg: 'bg-teal-50',
      icon: 'text-teal-600',
      accent: 'text-teal-800',
      border: 'border-teal-200',
      tag: 'bg-teal-100 text-teal-800'
    },
    purple: {
      bg: 'bg-purple-50',
      icon: 'text-purple-600',
      accent: 'text-purple-800',
      border: 'border-purple-200',
      tag: 'bg-purple-100 text-purple-800'
    }
  };

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            ネクストスタイルの3大特長
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            他にはない独自の教育システムで、生徒一人ひとりの可能性を最大限に引き出します
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${colorClasses[feature.color as keyof typeof colorClasses].bg} rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group border ${colorClasses[feature.color as keyof typeof colorClasses].border}`}
            >
              {/* 画像 */}
              <div className="mb-6 rounded-xl overflow-hidden shadow-md">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* アイコンとタイトル */}
              <div className="mb-6">
                <div className={`w-16 h-16 ${colorClasses[feature.color as keyof typeof colorClasses].bg} rounded-full flex items-center justify-center mb-4 mx-auto shadow-md`}>
                  <i className={`${feature.icon} text-3xl ${colorClasses[feature.color as keyof typeof colorClasses].icon}`}></i>
                </div>
                <h3 className={`text-2xl font-bold ${colorClasses[feature.color as keyof typeof colorClasses].accent} mb-2 text-center`}>
                  {feature.title}
                </h3>
                <p className={`text-lg font-medium ${colorClasses[feature.color as keyof typeof colorClasses].icon} text-center mb-4`}>
                  {feature.subtitle}
                </p>
              </div>

              {/* 説明 */}
              <p className="text-gray-700 leading-relaxed mb-6 text-center">
                {feature.description}
              </p>

              {/* タグ */}
              <div className="flex flex-wrap gap-2 justify-center">
                {feature.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className={`px-3 py-1 rounded-full text-sm font-medium ${colorClasses[feature.color as keyof typeof colorClasses].tag}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* 詳細ボタン */}
              <div className="text-center mt-6">
                <button className={`${colorClasses[feature.color as keyof typeof colorClasses].icon} hover:underline font-medium cursor-pointer flex items-center justify-center mx-auto gap-1`}>
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
